import api from '../../utils/axios.js';

const paymentPeriodRequestByExpertID = async (expertId) => {
	const { data } = await api.get(
		`/payment-period-requests?search[expertId]=${expertId}`
	);

	return data;
};

const createPaymentPeriodRequest = async (expertId, oldPeriod, newPeriod) => {
	const { data } = await api.post(`/payment-period-requests`, {
		expertId,
		oldPeriod,
		newPeriod,
	});

	return data;
};

const requestService = {
	paymentPeriodRequestByExpertID,
	createPaymentPeriodRequest,
};

export default requestService;
